<template>
  <AuthLayout>
    <template #title>Connexion</template>
    <template #subTitle>Bienvenue sur king recharge</template>
    <template #redirectQuestion>Pas encore de compte ?</template>
    <template #redirectLink>
      <router-link to="/register" class="font-bold text-secondary-400 hover:text-secondary-300 transition-colors underline decoration-white/30 underline-offset-4">Créer un compte</router-link>
    </template>

    <div class="bg-white/95 backdrop-blur-md rounded-[2rem] shadow-2xl shadow-gray-200/60 p-8 border border-white/70">
      <form
        class="space-y-5"
        v-bus:EVENTS.USER.LOGIN.submit.prevent
        v-redirect-on="{
          event: $constants.EVENTS.USER.LOGIN_SUCCESS,
          to: '/matches'
        }"
      >
        <!-- Email -->
        <div class="space-y-2">
          <label class="text-xs font-bold text-secondary-600 uppercase tracking-wider">email</label>
          <div class="relative group">
            <input
              name="email"
              type="email"
              required
              class="w-full px-4 py-4 pl-12 rounded-2xl border-2 border-gray-100 focus:border-secondary-400 focus:ring-4 focus:ring-secondary-100 transition-all bg-gray-50/50 text-sm placeholder:text-gray-400"
              placeholder="votre@email.com"
            />
            <svg class="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 group-focus-within:text-secondary-500 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
          </div>
        </div>

        <!-- Mot de passe -->
        <div class="space-y-2">
          <label class="text-xs font-bold text-secondary-600 uppercase tracking-wider">Mot de passe</label>
          <div class="relative group">
            <input
              name="password"
              type="password"
              required
              class="w-full px-4 py-4 pl-12 rounded-2xl border-2 border-gray-100 focus:border-secondary-400 focus:ring-4 focus:ring-secondary-100 transition-all bg-gray-50/50 text-sm placeholder:text-gray-400"
              placeholder="votre mot de passe"
            />
            <svg class="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 group-focus-within:text-secondary-500 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
        </div>

        <!-- Mot de passe oublié -->
        <div class="flex justify-end -mt-1">
          <button
            type="button"
            class="text-xs font-semibold text-secondary-500 hover:text-secondary-600 transition-colors"
            @click="$bus.emit($constants.EVENTS.PASSWORD_RESET.REQUESTED)"
          >
            mot de passe oublié ?
          </button>
        </div>

        <!-- Bouton -->
        <button
          type="submit"
          class="w-full py-4 px-6 bg-gradient-to-r from-secondary-500 via-secondary-600 to-secondary-500 hover:from-secondary-600 hover:via-secondary-700 hover:to-secondary-600 text-white font-bold rounded-2xl shadow-lg shadow-secondary-500/25 hover:shadow-xl hover:shadow-secondary-500/35 transition-all duration-300 transform hover:scale-[1.01] active:scale-[0.99] relative overflow-hidden"
          :disabled="$stores?.user?.state?.loading"
          :loading="$stores?.user?.state?.loading"
        >
          <span class="relative z-10">se connecter</span>
        </button>
      </form>
    </div>
  </AuthLayout>
</template>
